import React, { useEffect, useState } from 'react';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const principios = [
  {
    id: 1,
    color: '#621132',
    title: "Principio 1. - Mostrar actitud de respaldo y compromiso.",
    items: [

       { label: "Código de Ética", url: "/micro/principio1/1. Código de Ética.pdf" },
      { label: "Código de Conducta", url: "/micro/principio1/2. Código de Conducta.pdf" },
      {  label: "Carta de conocimiento del Código de Ética y Código de Conducta", url: "/micro/principio1/3. Carta de conocimiento del Código de Ética y Código de Conducta.pdf" },
      {  label: "Lineamientos Generales que Establecen las Bases para la Integración, Organización y Funcionamiento del Comité de Ética y Prevención de Conflictos de interés",url: "/micro/principio1/4. Lineamientos Generales que Establecen las Bases para la Integración, Organización y Funcionamiento del Comité de Ética y Prevención de Conflictos de interés.pdf" },
      {  label: "Medios de difusión para dar a conocer el Código de Ética y Código de Conducta", url: "/micro/principio1/5. Medios de difusión para dar a conocer el Código de Ética y Código de Conducta.pdf" },
      {  label: "Integración del Comité de Ética y Prevención de Conflictos de interés.", url: "/micro/principio1/6.Integración del Comité de Ética y Prevención de Conflictos de interés" },
      {  label: "Lineamientos Generales que Establecen las Bases para la Integración, Organización y Funcionamiento del Comité de Ética y Prevención de Conflictos de interés", url: "/micro/principio1/3. Carta.pdf" },
      {  label:  "Programa de Trabajo Anual del Comité de Ética y Prevención de Conflictos de Interésa", url: "/micro/principio1/3. Carta.pdf" }
     
     
    ]
  },

   {
    id: 2,
    color: '#9e2348',
    title: "Principio 2. - Ejercer la responsabilidad de Vigilancia.",
    items: [
      { label: "Órgano Interno de Control", url: "/micro/1. Código de Ética.pdf" },
      { label: "Procedimiento para vigilar, detectar, investigar y documentar las posibles violaciones a los principios éticos y a las normas de conducta", url: "/micro/2. Procedimiento de Vigilancia.pdf" },
      { label: "Medios de denuncia", url: "/micro/3. Medios de denuncia.pdf" },
      { label: "Comités Internos de Funciones Operativas de la Secretaría", url: "/micro/4. Comités Internos.pdf" }
    ]
  },
  {
    id: 3,
    color: '#a98188',
    title: "Principio 3. - Establecer la estructura, responsabilidad y autoridad.",
    items: [
    { label: "Reglamento Interior de la Secretaría de Contraloría del Poder Ejecutivo del Estado de Hidalgo", url: "/micro/principio3/1. Reglamento Interior de la Secretaría de Contraloría del Poder Ejecutivo del Estado de Hidalgo.pdf" },
      { label: "Organigrama", url: "/micro/principio3/2. Organigrama.pdf" },
      { label: "Manual de Organización", url: "/micro/principio3/3.Manual de Organización 2026.pdf" },
      { label: "Manual de Procedimientos Administrativos", url: "/micro/principio3/4.Manual de Procedimientos Administrativos.pdf" }
    ]
  },
  {
    id: 4,
    color: '#94824d',
    title: "Principio 4. - Demostrar compromiso con la competencia profesional.",
    items: [
     { label:  "Catálogo de Perfiles y Cargos de la Secretaría de Contraloría del Poder Ejecutivo del Estado de Hidalgo",url: "/micro/principio4/1.Manual de Procedimientos Administrativos.pdf"},
     { label:  "Lineamientos Administrativos",url: "/micro/principio4/2. Lineamientos Administrativos.pdf"},
    { label:   "Plan Anual de Capacitación y Desarrollo",url: "/micro/principio4/3.Manual de Procedimientos Administrativos.pdf"},
     { label:  "Procedimiento o mecanismo formalizado para evaluar el desempeño del personal",url: "/micro/principio4/4.Manual de Procedimientos Administrativos.pdf"},
    { label:   "Lineamientos del Proceso de Inducción Institucional e Inducción al Cargo",url: "/micro/principio4/5.Manual de Procedimientos Administrativos.pdf"},
    { label:   "Cuestionario de Clima Organizacional y No Discriminación",url: "/micro/principio4/6.Manual de Procedimientos Administrativos.pdf"},
    ]
  },
  {
    id: 5,
    color: '#645a5c',
    title: "Principio 5. - Establecer la Estructura para el Reforzamiento de la Rendición de Cuentas.",
    items: [

     { label:  "Coordinación de actividades referentes a control interno",url: "/micro/principio5/1.Manual de Procedimientos Administrativos.pdf"},
     { label:  "Mecanismo para Responsabilizar al Personal por sus Obligaciones Especificas en materia de Control Interno",url: "/micro/principio5/2. Lineamientos Administrativos.pdf"},
   
    ]
  }
];

const AmbienteControl = () => {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const toggleAccordion = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <>
      <HeaderSCI title="COMPONENTES DEL CONTROL INTERNO" />

      <div className="container ci-nav pt-4">
        {/* Title pill */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-5 d-flex justify-content-center">
            <div className="ci-nav__btn--pill" style={{ cursor: 'default', margin: 0 }}>
              Ambiente de Control
            </div>
          </div>
        </div>

        {/* Text Description */}
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-10">
            <p className="ci-desc-text">
              Es la base del control interno, la cual proporciona disciplina y estructura para apoyar al personal en la consecución de los objetivos institucionales.
            </p>
          </div>
        </div>

        {/* Accordion / Toggle List */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            {principios.map((prin) => {


              const isExpanded = expandedId === prin.id;

              return (
                <div key={prin.id} className="mb-2">
                  {/* Header Button */}
                  <div 
                    className="ci-nav__btn ci-nav__btn--doc" 
                    onClick={() => toggleAccordion(prin.id)}
                    style={{ cursor: 'pointer', padding: '8px 12px' }}
                  >
                    <div className="ci-nav__icon" style={{ backgroundColor: prin.color }}>
                      <i className="fa-solid fa-id-card"></i>
                    </div>
                    <span className="ci-nav__label ci-nav__label--doc" style={{ fontSize: '1rem', color: '#621132' }}>
                      {prin.title}
                    </span>
                  </div>

                  {/* Expanded Content */}
                  <div className={`ci-accordion-wrapper ${isExpanded ? 'is-open' : ''}`}>
                    <div className="ci-accordion-inner">
                      {prin.items.length > 0 ? (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <ul style={{ color: prin.color, fontSize: '0.95rem', fontStyle: 'italic', lineHeight: '1.6' }}>
                            {prin.items.map((item, idx) => (
                                <li key={idx} className="mb-2">
                                  <a 
                                    href={item.url || "#"}
                                    target={item.url ? "_blank" : "_self"}
                                    rel={item.url ? "noopener noreferrer" : ""}
                                    style={{ color: '#621132' }}
                                  >
                                    {item.label}
                                  </a>
                                </li>
                              ))}
                         </ul>
                        </div>
                      ) : (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <p style={{ color: '#621132', fontSize: '0.95rem', fontStyle: 'italic' }}>
                            No hay documentos disponibles.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AmbienteControl;
